const API_BASE = import.meta.env.VITE_API_BASE_URL || "https://assocham.org/api";

function formatDate(dateISO) {
  const d = new Date(dateISO);
  return d.toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });
}

function mapPressCoverage(pc) {
  return {
    id: pc.id,
    title: pc.title,
    dateISO: pc.dateISO,
    displayDate: formatDate(pc.dateISO),
    excerpt: "",              // press_coverages table doesn't carry a description in the legacy schema
    source: pc.source || "",
    externalUrl: pc.externalUrl, // NewsCard: agar ye hai to naya tab mein khulega, internal route nahi
    subjects: [],
    types: ["Press Coverage"],
    regions: [],
  };
}

export async function fetchPressCoverages({ search = "", startDate = "", endDate = "" } = {}) {
  const params = new URLSearchParams();
  if (search) params.set("search", search);
  if (startDate) params.set("start_date", startDate);
  if (endDate) params.set("end_date", endDate);

  const res = await fetch(`${API_BASE}/get_press_coverages.php?${params.toString()}`);
  if (!res.ok) throw new Error("Failed to fetch press coverage");
  const json = await res.json();
  if (!json.success) throw new Error(json.error || "Failed to fetch press coverage");
  return json.data.map(mapPressCoverage);
}